import locationData from "./locationData.json";

// Add/remove conditions or cities in locationData.json.
// Every condition/city pair automatically becomes a page.
// URL format: /{condition-slug}-psychiatrists-in-{city-slug}-{stateAbbr}
// Example: /depression-psychiatrists-in-columbus-oh

const slugify = (s) =>
    s
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

const buildSlug = ({ condition, city, stateAbbr }) =>
    `${slugify(condition)}-psychiatrists-in-${slugify(city)}-${stateAbbr.toLowerCase()}`;

const rawLocations = locationData.cities.flatMap((location) =>
    locationData.conditions.map((condition) => ({
        condition,
        ...location,
    })),
);

const locations = rawLocations.map((entry) => ({
    ...entry,
    slug: buildSlug(entry),
}));

export default locations;
